var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NLabelAndValue',{attrs:{"label":_vm.$attrs.label},scopedSlots:_vm._u([{key:"valueContent",fn:function(){return [_vm._v(" "+_vm._s(_vm.hijriDate)+" "),_c('span',{staticStyle:{"font-size":"smaller","color":"#435363"}},[_vm._v(" ("+_vm._s(_vm.miladiDate)+") ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }